import { classes } from 'html-classes';

import ProductCardM from '~/components/ProductCardV3/variants/ProductCardM/ProductCardM';

import { ProductsGridProps } from './interfaces';
import styles from './ProductsGrid.module.scss';

/**
 * ProductsGrid - Displays products in a responsive grid layout
 * Responsive styles are handled via CSS media queries (mobile-first approach)
 *
 * @example
 * ```tsx
 * <ProductsGrid
 *   title="Recommended Products"
 *   items={products}
 *   skeletonComponent={<Spinner />}
 * />
 * ```
 */
const ProductsGrid = ({
  title,
  items,
  skeletonComponent,
  className,
  isRatingShown,
  showColorVariants,
  hideButton,
}: ProductsGridProps) => {
  if (skeletonComponent && items.length === 0) {
    return <div className={styles.container}>{skeletonComponent}</div>;
  }

  if (items.length === 0) {
    return null;
  }

  const showHeader = !!title;

  return (
    <div className={classes([styles.container, className])}>
      {showHeader && (
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
        </div>
      )}
      <div className={styles.grid}>
        {items.map((product) => (
          <ProductCardM
            key={product.id}
            product={product}
            isRatingShown={isRatingShown}
            showColorVariants={showColorVariants}
            hideButton={hideButton}
            className={styles.card}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductsGrid;
